import { Form } from "antd";
import { Formik } from "formik";
import React, { useEffect, useState } from "react";
import { FundsService } from "../../../../../../services/FundService/Fund.service";
import InputField from "../../../../../../shared/components/InputField";
import { useDebouncer } from "../../../../../../shared/hooks/useDebouncer";

interface OnboardingNotesProps {
  id: number;
}

const OnboardingNotes = (props: OnboardingNotesProps) => {
  const { id } = props;
  const [notes, setNotes] = useState<{ description: string }>();

  const fetchNotes = () => {
    FundsService.fetchNotes(
      "OnboardingItem",
      id.toString(),
      (response) => {
        setNotes(response);
      },
      (err) => {
        // ;
      },
      () => { }
    );
  };

  const updateNotes = (notes) => {
    FundsService.updateNotes(
      "OnboardingItem",
      id.toString(),
      notes,
      () => { },
      () => { },
      () => { }
    );
  };

  useEffect(() => {
    fetchNotes();
  }, []);

  const handleUpdate = useDebouncer((description) => {
    updateNotes({ description });
  }, 1000)

  return (
    <Formik enableReinitialize initialValues={notes} onSubmit={() => { }}>
      {({ setFieldValue, values, resetForm, isValid }) => {
        return (
          <Form>
            <div className="onboarding-notes">
              <InputField
                showLabel={false}
                onChange={(event) => {
                  setFieldValue("description", event.target.value)
                  //@ts-ignore
                  handleUpdate(event.target.value)
                }}
                placeholder={"Add your notes..."}
                name="description"
                type="textarea"
              />
            </div>
          </Form>
        );
      }}
    </Formik>
  );
};

export default OnboardingNotes
